<template>
  <div style="width:100%">
    <v-row class="ml-3 mt-n9 mb-3">
      <div class='headline'>Настройки</div>
    </v-row>
    <v-row align="center" justify="center" class="subtitle-1">
      <v-col>
        <v-card class="mx-auto pa-5" max-width="1500px" width="100%">Для подписки на электронную квитанцию:<br>- Нажмите на кнопку "Добавить"<br>- Введите номер лицевого счёта и e-mail<br>- Нажмите на кнопку "Сохранить"<br>- Нажмите на кнопку "Сохранить настройки"</v-card>
      </v-col>
      </v-row>
    <v-card class="mx-auto pa-5" max-width="1500px" width="100%">
      <v-list two-line subheader>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Лицевые счета</v-list-item-title>

            <v-container fluid>

              <v-data-table :headers="headers" :items="accounts" hide-default-footer style="border-bottom: 1px solid lightgrey;">
                <template v-slot:top>
                  <v-toolbar flat style="border-bottom: 1px solid lightgrey;">
                    <v-dialog v-model="dialog" max-width="360px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark class="mb-2 ml-n4" v-bind="attrs" v-on="on" small>
                          + Добавить
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-form v-model="validAccount">
                                  <v-text-field v-model="editedItem.number" label="Л/с" :rules="[rules.accountNumber, rules.required]" v-mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"></v-text-field>
                                  <v-text-field v-model="editedItem.email" label="e-mail" :rules="[rules.email]"></v-text-field>
                                </v-form>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">
                            Отмена
                          </v-btn>
                          <v-btn :disabled="!validAccount" color="blue darken-1" text @click="save">
                            Сохранить
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5">Удалить лицевой счёт № {{ editedItem.number }}?</v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete">Отмена</v-btn>
                          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.isSubscribed="{ item }">
                  <v-simple-checkbox v-model="item.isSubscribed" :ripple="false"></v-simple-checkbox>
                </template>
                <template v-slot:item.paperBill="{ item }">
                  <v-simple-checkbox v-model="item.paperBill" :ripple="false"></v-simple-checkbox>
                </template>
                <template v-slot:item.email="{ item }">
                  <v-edit-dialog :return-value.sync="editedItem.email" @save="saveEmail(item)" @open="openEmail(item)" large save-text="Сохранить" cancel-text="Отменить">
                    {{ item.email }}
                    <template v-slot:input>
                      <v-text-field v-model="item.email" :rules="[rules.email]" label="Edit" single-line counter></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </template>
                <!--<template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
                dark
              >
                Сброс
              </v-btn>
            </template>-->
              </v-data-table>
              <template>
                <div class="mt-2">
                  * Подписываясь, вы даёте согласие на

                  <v-dialog v-model="dialog2" persistent max-width="794">
                    <template v-slot:activator="{ on, attrs }">
                      <a color="primary" v-bind="attrs" v-on="on">
                        обработку персональных данных
                      </a>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        Согласие на обработку персональных данных
                      </v-card-title>
                      <v-card-text style="color: rgb(0 0 0 / 84%);">
                        <p> 1. Общие положения</p>
                        <p>Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые ООО «Новая Энергетика» (далее – Оператор).</p>
                        <p>1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.</p>
                        <p>1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее – Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта lk.newen.pro.</p>
                        <p>2. Основные понятия, используемые в Политике</p>
                        <p>2.1. Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники;</p>
                        <p>2.2. Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных);</p>
                        <p>2.3. Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу lk.newen.pro.</p>
                        <p>2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных, и обеспечивающих их обработку информационных технологий и технических средств;</p>
                        <p>2.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту персональных данных;</p>
                        <p>2.6. Обработка персональных данных – любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;</p>
                        <p>2.7. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными;</p>
                        <p>2.8. Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта lk.newen.pro.</p>
                        <p>2.9. Пользователь – любой посетитель веб-сайта lk.newen.pro.</p>
                        <p>2.10. Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;</p>
                        <p>2.11. Распространение персональных данных – любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом;</p>
                        <p>2.12. Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу;</p>
                        <p>2.13. Уничтожение персональных данных – любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и (или) уничтожаются материальные носители персональных данных.</p>
                        <p>3. Оператор может обрабатывать следующие персональные данные Пользователя</p>
                        <p>3.1. Электронный адрес;</p>
                        <p>3.2. Вышеперечисленные данные далее по тексту Политики объединены общим понятием Персональные данные.</p>
                        <p>4. Цели обработки персональных данных</p>
                        <p>4.1. Цель обработки персональных данных Пользователя — информирование Пользователя посредством отправки электронных писем предоставление доступа Пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте lk.newen.pro ;</p>
                        <p>4.2. Также Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах, специальных предложениях и различных событиях. Пользователь всегда может отказаться от получения информационных сообщений, создав обращение на странице личного кабинета lk.newen.pro/tickets с пометкой «Отказ от уведомлений о новых продуктах и услугах и специальных предложениях».</p>
                        <p>4.3. Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Пользователей на сайте, улучшения качества сайта и его содержания.</p>
                        <p>5. Правовые основания обработки персональных данных</p>
                        <p>5.1. Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и/или отправки Пользователем самостоятельно через специальные формы, расположенные на сайте lk.newen.pro. Заполняя соответствующие формы и/или отправляя свои персональные данные Оператору, Пользователь выражает свое согласие с данной Политикой.</p>
                        <p>5.2. Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера Пользователя (включено сохранение файлов «cookie» и использование технологии JavaScript).</p>
                        <p>6. Порядок сбора, хранения, передачи и других видов обработки персональных данных</p>
                        <p>Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных.</p>
                        <p>6.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.</p>
                        <p>6.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства.</p>
                        <p>6.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору обращения в личном кабинете на странице lk.newen.pro/tickets с пометкой «Актуализация персональных данных».</p>
                        <p>6.4. Срок обработки персональных данных является неограниченным. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору обращения в личном кабинете на странице lk.newen.pro/tickets с пометкой «Отзыв согласия на обработку персональных данных».</p>
                        <p>7. Трансграничная передача персональных данных</p>
                        <p>7.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных.</p>
                        <p>7.2. Трансграничная передача персональных данных на территории иностранных государств, не отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия согласия в письменной форме субъекта персональных данных на трансграничную передачу его персональных данных и/или исполнения договора, стороной которого является субъект персональных данных.</p>
                        <p>8. Заключительные положения</p>
                        <p>8.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью обращения в личном кабинете на странице http://lk.newen.pro/tickets.</p>
                        <p>8.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией.</p>
                        <p>8.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу lk.newen.pro/privacy.</p>


                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="dialog2 = false">
                          Закрыть
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  .
                </div>
              </template>
            </v-container>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" @click="saveSettings" dark :class="{ 'disable-events': searchDialog }">
          Сохранить настройки
        </v-btn>
      </v-card-actions>

    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false">
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </div>
</template>

<script>
import { downloadFile, convertDate, parseDate, getTodayDate, cleanNumber, wrapsNumber } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsView',

  data: () => ({
    searchDialog: false,
    dialog: false,
    snack: false,
    snackColor: '',
    snackText: '',
    validAccount: false,
    validEmail: false,
    dialog2: false,
    dialogDelete: false,
    headers: [
      { text: 'Номер Л/С', value: 'number', sortable: false, align: 'start' },
      { text: 'Подписаться на рассылку электронных квитанций', value: 'isSubscribed', sortable: false, align: 'center' },
      { text: 'Отказаться от получения бумажных квитанций *', value: 'paperBill', sortable: false, align: 'center' },
      { text: 'E-mail', value: 'email', sortable: false, align: 'center' },
      { text: '', value: 'actions', sortable: false, align: 'end' },
    ],
    accounts: [],
    editedIndex: -1,
    checkbox1: false,
    checkbox2: false,
    editedItem: {
      'number': '', 'isSubscribed': false, 'paperBill': false, 'email': ''
    },
    defaultItem: {
      'number': '', 'isSubscribed': false, 'paperBill': false, 'email': ''
    },
    rules: {
      required: value => !!value || 'Обязательное поле',
      accountNumber: v => !v || /^(\d{3}(-)){3}(\d){3}$/.test(v) || 'Формат: 000-000-000-000',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Неверный формат e-mail'
      }
    },
  }),
  computed: {
    ...mapGetters({
      userLogin: 'user/userLogin',
      userEmail: 'user/userEmail',
      userAccounts: 'user/userAccounts'
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'Новый лицевой счёт' : 'Редактировать'
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    }
  },
  created: function() {
    this.accounts = this.userAccounts
    this.editedItem.email = this.userEmail
    this.defaultItem.email = this.userEmail
  },
  methods: {
    saveEmail(item) {
      if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(item.email)) {
        item.email = this.editedItem.email
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Неверный формат e-mail'
      }
    },
    cancelEmail() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Отменено'
    },
    openEmail(item) {
      this.editedIndex = this.accounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },
    closeEmail() {
      console.log('Dialog closed')
    },
    editItem(item) {
      this.editedIndex = this.accounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (item.email == '') this.editedItem.email = this.userEmail
      this.dialog = true
    },

    deleteItem(item) {
      this.editedIndex = this.accounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.accounts.splice(this.editedIndex, 1)
      this.closeDelete()
      //this.saveSettings()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.accounts[this.editedIndex], this.editedItem)
      } else {
        this.editedItem['isSubscribed'] = true
        this.editedItem['paperBill'] = true
        this.accounts.push(this.editedItem)
      }
      this.close()
      //this.saveSettings()
    },
    checkSettings: function() {
      for (let i in this.accounts) {
        if (this.accounts[i].paperBill && !this.accounts[i].isSubscribed) {
          return { 'result': false, 'message': 'Чтобы отказаться от рассылки бумажных квитанций, необходимо быть подписаным на электронную рассылку.' }
        }
      }
      return { 'result': true, 'message': '' }
    },
    saveSettings: async function() {
      let checkRes = this.checkSettings()
      if (!checkRes.result) {
        await this.$store.dispatch('notification/setSystemNotification', { message: checkRes.message, type: 'notification' })
      }
      else {
        this.searchDialog = true
        try {
          const resp = await this.$api.Account.saveUserSettings(this.accounts.map((item) => {
            return {
              'account': cleanNumber(item.number),
              'isSubscribed': item.isSubscribed,
              'paperBill': item.paperBill,
              'email': item.email
            }
          }))
          let message = ''
          if (resp.data.not_found.length != 0) {
            message = message + `Следующие лицевые счета не существуют: ${resp.data.not_found.join(', ')}. `
            this.accounts = this.accounts.filter((item) => !resp.data.not_found.includes(cleanNumber(item.number)))
          }
          if (resp.data.occupied.length != 0) {
            message = message + `Следующие лицевые счета заняты: ${resp.data.occupied.join(', ')}. `
            this.accounts = this.accounts.filter((item) => !resp.data.occupied.includes(cleanNumber(item.number)))
          }
          this.accounts = resp.data.accounts.map((item) => {
            item.number = wrapsNumber(item.number)
            return item
          })
          await this.$store.dispatch('user/setUserAccounts', this.accounts)
          //if (this.to) location.href = this.to
          this.searchDialog = false
          await this.$store.dispatch('notification/setSystemNotification', { message: message + 'Настройки сохранены.', type: 'notification' })
        } catch (e) {
          this.searchDialog = false
          const err = e
          let error = 'Во время выполнения запроса произошла ошибка'
          if (e.response.status == 401) {
            error = 'Сессия истекла. Пожалуйста, зайдите в учётную запись и повторите действие.'
          }
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        }
      }
    }
  }
}

</script>

<style scoped>
.v-text-field {
  max-width: 300px;
  font-size: 15px;
}

.v-btn.picker {
  margin-top: 16px;
  padding-left: 10px;
  padding-right: 10px;
}

@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
  .v-data-footer__select {
    display: none !important;
    /*margin-right: 160px!important;*/
  }

  .v-data-footer__pagination {
    display: none !important;
  }

  .container--fluid {
    max-width: 90%;
  }
}

.heat-list {
  height: 200px;
  overflow-y: auto;
  border: 1px solid rgb(193 193 193);
  /*min-width: 500px;*/
}

.disable-events {
  pointer-events: none;
  opacity: 0.5;
}
</style>
